module.exports = __webpack_public_path__ + "static/media/fly0183.08cb92b9.webp";